import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    flexGrow: 1,
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'auto',
  },
  loaderBox: {
    width: '100%',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  skeleton: {
    width: '100%',
    height: 50,
    borderRadius: 8,
    marginBottom: theme.spacing(1),
  },
  emptyLabel: {
    display: 'flex',
    padding: [theme.spacing(1)],
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: theme.palette.colors.warning,
  },
}));



// WEBPACK FOOTER //
// ./src/components/AdminDashboard/components/LoanOfficersList/useStyles.js